import { axiosClientv1 } from "./apiClient";
import { ApiResponse, HsCode } from "../Types";

export const GetHsCodes = async (): Promise<ApiResponse<HsCode[]>> => {
  try {
    const response = await axiosClientv1.get(`/hs-codes/active`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load HS codes.",
      data: [],
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const CreateHsCode = async (formData: {
  code: string;
  description?: string;
}): Promise<ApiResponse<HsCode>> => {
  try {
    const response = await axiosClientv1.post(`/hs-codes/create`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create HS code.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const UpdateHsCode = async (formData: {
  id: string;
  code: string;
  description?: string;
}): Promise<ApiResponse<HsCode>> => {
  try {
    const response = await axiosClientv1.post(`/hs-codes/update`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update HS code.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const DeleteHsCode = async (id: string): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/hs-codes/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete HS code.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};
